import { render, staticRenderFns } from "./SexTypeTrendChart.vue?vue&type=template&id=3e83e564"
import script from "./SexTypeTrendChart.vue?vue&type=script&lang=js"
export * from "./SexTypeTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports